import { buildPermission } from "common/utils/auth";
import { Header } from "portal/components/header/Header";
import { IconButton, Typography } from "@mui/material";
import { ImplementForm } from "./ImplementForm";
import { Page } from "portal/components/Page";
import {
  PermissionAction,
  PermissionDomain,
  PermissionResource,
} from "protos/portal/auth";
import { useNavigate, useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { withAuthorizationRequired } from "portal/components/auth/WithAuthorizationRequired";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React, { FC } from "react";

interface EditImplementProps {}
export const _EditImplement: FC<EditImplementProps> = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { implementId } = useParams();
  return (
    <Page>
      <Header
        title={t("views.autotractor.equipment.implements.editImplement")}
      />
      <div className="flex flex-col">
        <div className="flex gap-2">
          <IconButton color="info" onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" className="my-auto">
            {t("views.autotractor.equipment.implements.editImplement")}
          </Typography>
        </div>
        <ImplementForm implementId={implementId} />
      </div>
    </Page>
  );
};

export const EditImplement = withAuthorizationRequired(
  {
    or: [
      buildPermission(
        PermissionAction.update,
        PermissionResource.atk_equipment,
        PermissionDomain.all
      ),
      buildPermission(
        PermissionAction.update,
        PermissionResource.atk_equipment,
        PermissionDomain.customer
      ),
    ],
  },
  _EditImplement
);
